import { useUserCarInfo } from '@/entities/car';
import { TOGGLE_OPTION } from '@/entities/station';
import { useAuth } from '@/entities/user';
import { Toggle } from '@/shared/ui';
import { useNaverMapStore } from '@/widgets/naver-map';
import BottomSheetList from './BottomSheetList';
import CarRegistrationBanner from './CarRegistrationBanner';

const StationListPage = () => {
	const filter = useNaverMapStore((store) => store.filter);
	const sortStations = useNaverMapStore((store) => store.sortStations);
	const { isLoggedIn, isLoading: isAuthLoading } = useAuth();
	const { carInfo } = useUserCarInfo();
	const showCarRegistrationBanner = !isAuthLoading && (!isLoggedIn || !carInfo);

	return (
		<>
			<Toggle
				items={TOGGLE_OPTION}
				onClick={(value) => sortStations(value)}
				value={filter}
			/>
			{showCarRegistrationBanner && (
				<CarRegistrationBanner isLoggedIn={isLoggedIn} />
			)}
			<BottomSheetList />
		</>
	);
};

export default StationListPage;
